import styled from "styled-components";

export const CompanyContainerDetail = styled.table`
  border-collapse: separate;
  border-spacing: 20px;
  border-radius: 8px 8px 0 0;
  box-shadow: 1px 6px 10px 2px rgba(62, 165, 219, 0.12);
  & * {
    font-size: var(--font-size-sm);
  }
  .factor-btn {
    color: var(--primary-color);
  }
  @media screen and (max-width: 576px) {
    border-spacing: 10px;
  }
`;

export const FinancialTableWrapper = styled.div`
  background-color: var(--button-color-labs);
  border-radius: 0 0 8px 8px;
  overflow-x: overlay;
`;

export const FinancialTableDetail = styled.table`
  border-collapse: separate;
  border-spacing: 0;
  width: 80%;
  margin: 20px auto;
  th {
    border-top: 2px solid var(--primary-color);
  }
  th,
  td {
    text-align: center;
    padding: 10px 5px;
    border-right: 2px solid var(--primary-color);
    border-bottom: 2px solid var(--primary-color);
    &:last-child {
      border-left: 2px solid var(--primary-color);
    }
  }
`;
export const FinancialTableHeaderRow = styled.tr`
  th {
    background-color: var(--primary-color);
    color: white;
    border: 1px solid white;
    &:first-child {
      border-top-right-radius: var(--border-radius-1);
    }
    &:last-child {
      border-top-left-radius: var(--border-radius-1);
    }
  }
  th:last-child {
    border: none;
  }
`;
export const FinancialTableBodyRow = styled.tr`
  &:last-child {
    td:first-child {
      border-bottom-right-radius: var(--border-radius-1);
    }
    td:last-child {
      border-bottom-left-radius: var(--border-radius-1);
    }
  }
`;
